import React from 'react';
import PropTypes from 'prop-types';
import Mosvita from '../../ui/typography/mosvita';
import { ContainerDetailText } from './style';
import { HtmlRaw } from '../../components';

const CourseOnlineDetail = ({ title, body }) => (
  <ContainerDetailText>
    <Mosvita type="courseOnlineDetailTitle">{title}</Mosvita>
    <Mosvita type="courseOnlineDetailBody">
      <HtmlRaw html={body} />
    </Mosvita>
  </ContainerDetailText>
);

CourseOnlineDetail.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired
};

export default CourseOnlineDetail;
